import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import "./checkbox.scss";
export class Checkbox extends MithrilTsxComponent {
    view(v) {
        const { checked, onchange, disabled, ...rest } = v.attrs;
        return m("input", { type: "checkbox", className: "checkbox", checked: checked, disabled: disabled, onchange: (e) => onchange?.(e.target.checked), ...rest });
    }
}
